import React from 'react'
import './index.css'

const SelectOptions = (props) => {
  return (
    <section
      className={`options-wrap ${props.className}`}
      onClick={props.onClick}
    >
      <div className={`options-info`}>
        <div className={`options-info-title`}>{props.title}</div>
        <div className={`options-info-desc`}>{props.desc}</div>
      </div>
      <div className={`options-icon`}>
        <i className={`options-arrow`}></i>
      </div>
    </section>
  )
}

export default SelectOptions
